<template>
    <div class="nevs-content" v-if="loaded">
        <div class="nevs-content-top-buttons">
            <NevsButton v-if="!readonly" @click="saveClick()" class="success"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>
            <NevsButton v-if="!readonly" @click="approveClick(1)" class="success">
                {{ $LANG.Get('buttons.approve') }}
            </NevsButton>
            <NevsButton v-if="!readonly" @click="approveClick(0)" class="error">
                {{ $LANG.Get('buttons.deny') }}
            </NevsButton>
            <NevsButton v-if="!readonly" @click="approveClick(0, 'registri')" class="error">
                {{ $LANG.Get('buttons.denyRegisters') }}
            </NevsButton>
            <NevsButton @click="backClick" class="error"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <NevsCard class="registration-form">
            <NevsTextField :readonly="readonly" :error="registrationValidation.first_name" :label="$LANG.Get('fields.firstName') + ':'"
                           v-model="registration.first_name"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.last_name" :label="$LANG.Get('fields.lastName') + ':'"
                           v-model="registration.last_name"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.email" :label="$LANG.Get('fields.email') + ':'"
                           v-model="registration.email"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.name" :label="$LANG.Get('fields.name') + ':'"
                           v-model="registration.name"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.oib" :label="$LANG.Get('fields.oib') + ':'"
                           v-model="registration.oib"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.iban" :label="$LANG.Get('fields.iban') + ':'"
                           v-model="registration.iban"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.address" :label="$LANG.Get('fields.address') + ':'"
                           v-model="registration.address"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.postal_code" :label="$LANG.Get('fields.postalCode') + ':'"
                           v-model="registration.postal_code"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.city" :label="$LANG.Get('fields.city') + ':'"
                           v-model="registration.city"></NevsTextField>
            <NevsTextField :readonly="readonly" :error="registrationValidation.country" :label="$LANG.Get('fields.country') + ':'"
                           v-model="registration.country"></NevsTextField>
            <NevsCheckbox :error="registrationValidation.country" v-model="registration.tax_system" :label="$LANG.Get('fields.taxSystem')"></NevsCheckbox>
            <NevsCheckbox readonly v-model="approved" :label="$LANG.Get('fields.approved')"></NevsCheckbox>
            <NevsCheckbox readonly v-model="processed" :label="$LANG.Get('fields.processed')"></NevsCheckbox>
        </NevsCard>
    </div>
</template>

<script>
import Registration from '@/models/Registration.js';
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";

export default {
    name: "EntityRegistration",
    components: {NevsCheckbox, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            loaded: false,
            id: this.$route.params.id,
            registration: new Registration({}),
            registrationValidation: new Registration({}, true),
            readonly: true,
            approved: false,
            processed: false
        }
    },
    methods: {
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        approveClick(approved, denialType = 'standard') {
            let vm = this;
            let question = this.$LANG.Get('alerts.approvalQuestion');
            if (approved === 0) {
                question = (denialType === 'registri')
                    ? this.$LANG.Get('alerts.denialRegistersQuestion')
                    : this.$LANG.Get('alerts.denialQuestion');
            }
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: question, callback: (response) => {
                    if (response) {
                        this.$API.APICall('post', 'registrations/approve/' + this.id, {approved: approved, denial_type: denialType}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-registrations', {});
                                // vm.backClick();
                            }
                        });
                    }
                }
            });
        },
        saveClick() {
            let vm = this;
            this.$API.APICall('put', 'registrations/' + this.id, this.registration, (data, success) => {
                if (success) {
                    vm.$CROSS_TAB_BUS.TriggerEvent('reload-registrations', {});
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                    vm.backClick();
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'registrations');
        this.$store.commit('selectSubMenu', null);

        let vm = this;
        this.$API.APICall('get', 'registrations/' + this.id, {}, (data, success) => {
            if (success) {
                if (data.registration !== null) {
                    vm.registration.Fill(data.data);
                    vm.approved = data.registration.approved;
                    vm.processed = data.registration.processed;
                    vm.readonly = vm.processed == 1;
                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: vm.$LANG.Get('modules.registrations'),
                            link: '/registrations'
                        },
                        {
                            label: vm.registration.name,
                            link: null
                        }
                    ]);
                    vm.$nextTick(()=>{
                       vm.loaded = true;
                    });
                } else {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.serverError'), type: 'alert'});
                }
            } else {
                vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.serverError'), type: 'alert'});
            }
            vm.$nextTick(() => {
                vm.loaded = true;
            });
        });
    }
}
</script>

<style scoped>
.registration-form {
    max-width: 500px;
}
:deep(.nevs-content-top-buttons .nevs-button) {
    margin-right: 10px;
}
</style>